/**
 * True when `value` is safe to interpolate into a poll/API path segment.
 * Rejects null, undefined, empty strings, and the literal "undefined" string
 * that can leak from loosely-typed call sites before we have TypeScript.
 */
export function isQueryParamReady(value) {
    if (value == null) {
        return false;
    }
    if (value === '') {
        return false;
    }
    if (value === 'undefined') {
        return false;
    }
    return true;
}

/** True when every value is safe for URL path interpolation. */
export function hasRequiredQueryParams(...values) {
    return values.every(isQueryParamReady);
}

/**
 * Build a poll URL from a path prefix and segments, or null when any segment is missing.
 * @example buildPollUrl('/api/Invoice/GetInvoiceDataforCompany', companyId, customerId, page)
 */
export function buildPollUrl(pathPrefix, ...segments) {
    if (!hasRequiredQueryParams(...segments)) {
        return null;
    }
    return `${pathPrefix}/${segments.join('/')}`;
}
